// Central company configuration — edit all business details here.
export const COMPANY = {
  name: "Numeric Consulting & Solutions",
  tagline: "Strengthening Systems. Managing Risk. Building Resilience.",
  brandTagline: "Securing your processes.",
  description:
    "Numeric Consulting & Solutions is a management systems and ISO standards consulting company specializing in compliance, information security, cybersecurity, business continuity, quality management, IT governance, risk advisory and application development.",
  email: "info@numericconsultingsolutions.com",
  phone: "+234 803-307-1560",
  address: "Ajah, Lagos, Nigeria",
  linkedin: "https://www.linkedin.com/company/numeric-consulting-solutions/",
  parentName: "Numeric Technologies Ltd",
  parentSince: "2011",
  experienceYears: "40+",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "Our Approach", to: "/approach" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_OPTIONS = [
  "ISO 27001 Consulting",
  "ISO 22301 Consulting",
  "ISO 9001 Consulting",
  "ISO 38500 IT Governance",
  "PCI DSS Consulting",
  "Cybersecurity Assessment",
  "SWIFT CSP Assessment",
  "Vulnerability Assessment and Penetration Testing",
  "VAPT Remediation",
  "ISO Standards Training",
  "IT Consulting",
  "Application Development",
  "General Enquiry",
];

export const HERITAGE_CLIENTS = [
  "Access Bank Plc",
  "Guaranty Trust Bank Plc",
  "FCMB Nigeria Ltd",
  "Ecobank Nigeria Ltd",
  "Ecobank Eprocess Ghana",
  "Fidelity Bank Ghana",
  "Cellulant Nigeria Ltd",
];

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
